<template>
  <div>
    <div id="app">
      <router-view/>
    </div><!-- app_layer -->
    <div id="popup_layer"></div><!-- popup_layer -->
    <div id="comp_layer"></div><!-- comp_layer -->
    <loading :visible="showLoading" @close="closeLoading"></loading><!-- load_layer -->
    <div id="alert_layer"></div><!-- alert_layer -->
  </div>
</template>

<script>
import Loading from '@/views/components/Loading';
export default {
  components: {
    Loading,
  },
  computed: {
    showLoading () { return this.$store.getters['loading/show_loading']; },
  },
  methods: {
    closeLoading () {
      this.$store.commit('loading/set_loading', false);
    },
  },
};
</script>
<style lang="scss">
/************
* scss init
************/
* {
  margin: 0px;
  padding: 0px;
  margin-block-start: 0;
  margin-block-end: 0;
  font-family: "游ゴシック体",YuGothic,"游ゴシック Medium","Yu Gothic Medium","ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro","メイリオ",Meiryo,sans-serif;
}
body {
}
li {
  text-decoration: none;
  list-style: none;
}

/************
* scss common
************/
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#popup_layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 16, 56, 0.9);
  display: none;
}
#alert_layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: none;
  z-index: 10000;
}
.clear-both::after {
    content: "";
    display: block;
    clear: both;
}
/* checkbox */
input[type="checkbox"] {
  display: none;
}
input[type="checkbox"] + label {
  padding-left: 25px;
  position:relative;
  margin-right: 20px;
  font-weight: bold;
  color: #a0b19a;
  text-decoration: underline;
  box-sizing: border-box;
  cursor: pointer;
}
input[type="checkbox"] + label::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  border: 1px solid #999;
  border-radius: 4px;
  background-color: #FFF;
}
input[type="checkbox"]:checked + label {
  color: #7a4643;
  text-decoration: none;
}
input[type="checkbox"]:checked + label::after {
  content: "";
  display: block;
  position: absolute;
  top: -5px;
  left: 6px;
  width: 8px;
  height: 14px;
  transform: rotate(40deg);
  border-bottom: 3px solid #7a4643;
  border-right: 3px solid #7a4643;
}
/* radio */
input[type="radio"] {
    display: none;
}
input[type="radio"] + label{
    padding-left: 20px;
    position:relative;
    margin-right: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
input[type="radio"] + label::before{
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 15px;
    height: 15px;
    border: 1px solid #999;
    border-radius: 50%;
    background-color: #FFF;
}
input[type="radio"]:checked + label{
    color: #7a4643;
}
input[type="radio"]:checked + label::after{
    content: "";
    display: block;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 7px;
    height: 7px;
    background: #7a4643;
    border-radius: 50%;
}

input[type="button"],
input[type="submit"] {
  background: #373863;
  cursor: pointer;
  transition: all 0.2s ease;
}

input[type="button"]:hover,
input[type="submit"]:hover {
  background: #5e5f8e;
}

input[type="text"],
input[type="url"],
input[type="password"],
input[type="number"],
textarea{
    width: 100%;
    border: none;
    border-radius: 0;
    padding: 0;
    outline: 0;
    font-size: 1rem;
    resize: none;
    box-sizing: border-box;
    border-radius: 3px;
    background-color: #fefdf9;
    border-color: #b4b1a2;
}

input[type="text"],
input[type="url"],
input[type="password"],
input[type="number"],
textarea {
    border: 1px solid #ddd;
    padding: 3px 5px;
    &:focus {
        border-color: #584858;
    }
}
input[type="text"]:disabled,
input[type="url"]:disabled,
input[type="password"]:disabled,
input[type="number"]:disabled,
textarea:disabled {
  background-color: #eee;
}
::-webkit-input-placeholder, { /* WebKit, Blink, Edge */
    color:#bbb;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color:#bbb;
}
::placeholder{ /* Others */
    color:#bbb;
}
select {
  outline: 0;
}

select > option {
  background-color: #fffff3;
}
select:hover {
}
</style>
